
import { call, put, takeLatest } from 'redux-saga/effects';

import request from 'utils/request';
import authUtils from 'utils/auth/authUtils';

import { BACKEND_URL } from 'utils/constants';

import { FETCH_ME_REQUEST } from './constants';
import { fetchMeSuccess, fetchMeFailure } from './actions';

export function* doFetchMe() {
  const authToken = authUtils.getAuthToken();

  if(!authToken){
    yield put(fetchMeFailure());
    return;
  }

  try {
    const response = yield call(request, `${BACKEND_URL}/me/`, {
      headers: {
        Authorization: authToken,
      },
    });

    if (process.env.NODE_ENV !== 'production') {
      console.log('ME:', response);
    }

    if (response.profile_data) {
      yield put(fetchMeSuccess(response));
    } else {
      yield put(fetchMeFailure());
    }
  } catch (error) {
    console.error('fetchMe failed:', error.message || error);
    yield put(fetchMeFailure());
  }
}

export default function* homeSaga() {
  yield takeLatest(FETCH_ME_REQUEST, doFetchMe);
}
